module.exports = __webpack_public_path__ + "img/Print-icon.1fa9f7b1.svg";